import React, { useContext } from "react";
import { t } from "i18next";

import { ModalsContext } from "../../context/modals.context";
import { Modal } from "../Modal/Modal";

interface IInfoModalProps {
  title?: string;
  message: string;
  onOk?: () => any;
  onReload: boolean;
}

export const InfoModal: React.FC<IInfoModalProps> = ({
  title,
  message,
  onReload,
  onOk,
}) => {
  const { isModalVisible, clearModals } = useContext(ModalsContext);

  const handleCancel = () => {
    if (onReload) {
      window.location.reload();
    }
    clearModals();
  };

  const handleOk = () => {
    onOk && onOk();
    clearModals();
  };

  return (
    <Modal
      name="obavestenje"
      title={title}
      mask={true}
      onCancel={handleCancel}
      cancelText={t("COMMON.NAZAD")}
      onOk={handleOk}
      cancelButtonProps={{ type: "primary" }}
      okButtonProps={{ style: { display: "none" } }}
      open={isModalVisible("info")}
    >
      <p className="pl-25">{message}</p>
    </Modal>
  );
};
